
export default {
  SET_NEXT_SEQ_CODE: (state, payload) => state.nextSeqCode = payload,

  SET_ESTIMATES: (state, payload) => state.estimates = payload,
}